import { z } from 'zod';

/** Customer kind — residential vs commercial (core-data-model Q2). */
export const customerKind = z.enum(['residential', 'commercial']);
export type CustomerKind = z.infer<typeof customerKind>;

/**
 * M0 customer create input — the minimal shape the hello-tenant needs. The full
 * commercial fields (billing contact, terms, po_required, tax_exempt) land in M1.
 */
export const customerCreateInput = z.object({
  kind: customerKind,
  displayName: z.string().trim().min(1, 'Name is required').max(200),
  companyName: z.string().trim().max(200).optional(),
  email: z.string().trim().email().max(200).optional().or(z.literal('')),
  phone: z.string().trim().max(40).optional(),
  city: z.string().trim().max(120).optional(),
  state: z.string().trim().length(2).toUpperCase().optional().or(z.literal('')),
  /** Where they came from (matrix §6 "lead source"). Free text on purpose — a shop's
   *  channels are its own, and a fixed enum would be wrong for most of them. Blank is a
   *  real answer, and the lead-source report counts blanks rather than hiding them. */
  leadSource: z.string().trim().max(80).optional().or(z.literal('')),
});
export type CustomerCreateInput = z.infer<typeof customerCreateInput>;
